import { useRef, useEffect, useCallback } from "react";
import { useCallbackRef } from "./use-callback-ref";

/**
 * Uses a debounced function that delays invoking the callback until after `wait` milliseconds have elapsed since the
 * last time the debounced function was invoked.
 */
export function useDebounceCallback(callback, wait) {
  let leading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const timeout = useRef();
  const savedCallback = useCallbackRef(callback);
  useEffect(() => {
    window.clearTimeout(timeout.current);
    timeout.current = undefined;
  }, [wait, leading]);
  const fn = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (timeout.current === undefined && leading) {
      savedCallback(...args);
    }
    window.clearTimeout(timeout.current);
    timeout.current = window.setTimeout(() => {
      timeout.current = undefined;
      if (!leading) {
        savedCallback(...args);
      }
    }, wait);
  };
  return useCallback(fn, [wait, leading]);
}